<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Ad</label>
            <input type="text" class="form-control" v-model="value.Name" placeholder="Ad" />
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Soyad</label>
            <input type="text" class="form-control" v-model="value.Surname" placeholder="Soyad" />
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">E-Posta</label>
            <input type="text" class="form-control" v-model="value.Email" placeholder="E-Posta" />
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Telefon</label>
            <input type="text" class="form-control" v-model="value.PhoneNumber" placeholder="Telefon" />
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Plasiyer Kodu</label>
            <input type="text" class="form-control" v-model="value.SalesPersonCode" placeholder="Plasiyer Kodu" />
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Rol</label>
            <v-select-list :options="roles" v-model="role" placeholder="Rol" label="Name"></v-select-list>
        </div>
        <div class="col-12">
            <label class="form-label">Sorumlu Yöneticisi</label>
            <v-select-list :options="users" v-model="user" placeholder="Sorumlu Yöneticisi" label="FullName"></v-select-list>
        </div>
        <div class="col-12">
            <b-form-checkbox class="mb-50" id="EnableSSL" v-model="value.IsPaymentErrorResponsible">Ödeme Hataları Sorumlusu</b-form-checkbox>
        </div>
    </div>
</template>

<script>
import { RoleApi } from '@/api/role'
import { UserApi } from '@/api/user'
import {BFormCheckbox} from 'bootstrap-vue'

export default {
    components:{
        BFormCheckbox
    },
    props:{
        value:Object
    },
    data(){
        return{
            roles:[],
            users:[]
        }
    },
    mounted(){
        this.getRoles()
        this.getUsers()
    },
    methods:{
        getRoles(){
            RoleApi.List().then(res=>{
                this.roles = res.data.Data
            })
        },
        getUsers(){
            UserApi.ListWithoutSelectedUser({Id:this.value.Id}).then(res=>{
                this.users = res.data.Data
            })
        }
    },
    computed:{
        role:{
            get:function(){
                return this.roles.find(r=>r.Id == this.value.RoleGroupId)
            },
            set:function(value){
                this.value.RoleGroupId = value?.Id || null
            }
        },
        user:{
            get:function(){
                return this.users.find(r=>r.Id == this.value.ResponsibleUserId)
            },
            set:function(value){
                this.value.ResponsibleUserId = value?.Id || null
            }
        }
    }
}
</script>

<style>

</style>